import styled from "styled-components";
import React from "react";
import { LinkProps } from "Data/user";
import BtnIcon from "./Btn/BtnIcon";

interface LinkWithIconProps {
	data: LinkProps;
}

const Wrapper = styled.div``;

const LinkWithIcon: React.FC<LinkWithIconProps> = ({ data }) => {
	const { name, url } = data;
	const handleLinkClick = () => {
		window.open(url);
	};
	return (
		<Wrapper>
			<BtnIcon icon={name} onClick={handleLinkClick} />
		</Wrapper>
	);
};

export default LinkWithIcon;
